import { ERROR, FLUSH, MESSAGE, ADD_ENDROSMENT, ENDROSMENT_LIST } from './constants';

import { SERVER_ADDR, SLEEP_TIME, JWT_TOKEN } from '../../../constants';

export const addEndrosment = (formData) => async (dispatch, getState, api) => {
  try {
    const endrosments = getState().endrosment.list;

    const res = await api
      .post(`${SERVER_ADDR}endrosment`, { data: formData });

    const newList = endrosments.concat(res.body);

    dispatch({
      type: ADD_ENDROSMENT,
      result: newList
    });

  } catch (e) {
    console.log(e);
  }
}

export const get_endrosments = () => async (dispatch, getState, api) => {
  try {
    const res = await api
      .get(`${SERVER_ADDR}endrosment`);
    
    dispatch({
      type: ENDROSMENT_LIST,
      result: res.body
    });

  } catch (e) {
    console.log(e);
  }
}

export const deleteEndrosment = (id) => async (dispatch, getState, api) => {
  try {
    const res = await api
      .del(`${SERVER_ADDR}endrosment/${id}`);
    
    const endrosments = getState().endrosment.list;
    const newEndrosments = endrosments.filter(e => e.id !== id);

    dispatch({
      type: ENDROSMENT_LIST,
      result: newEndrosments
    });

  } catch (e) {
    console.log(e);
  }
}